import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* 系统菜单 */
import system from './system/system'
import permission from './system/permission'
import extension from './system/extension'
// import messageManagement from './messageManagement/index.js'//消息管理
// import officialAccountManagement from './officialAccountManagement/index.js' //公众号管理
// import timedPush from './timedPush/index.js' 定时推送
import warningException from './warningException/index.js'// 异常警告
import enterpriseWechat from './enterpriseWechat/index.js'// 企业微信
// import rankinglist from './rankinglist/index.js'

import enterprisewechatControl from './enterprisewechatControl/index.js'

// import merchantnumber from './merchantnumber/index.js'// 微信商户号
import anonymousLetter from './anonymousLetter/index.js'// 飞书管理
// import statistics from './statistics/index.js'// 统计
import avataracquisition from './avataracquisition/index.js'// 私域
// import eventmanagement from './eventManagement/index.js' // 活动管理
import domainnamedetect from './domainnamedetect/index.js' // 微信域名池
import mobilePhoneScanningCode from './mobilePhoneScanningCode/index.js' // 手机扫码

import operateCenter from './operateCenter/index.js'// 运营中心
import recordStatistics from './recordStatistics/index.js' // 数据报表
import merChant from './merChant/index.js'// 商户
import advertisement from './advertisement/index.js'// 广告
import wecomchat from './wecomchat/index.js'// 企业微信
// import detectEnterpriseWeChat from './detectEnterpriseWeChat/index.js' // 检测企业微信
// import userAnalysis from './userAnalysis/index'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      },
      {
        path: '/userAnalysis/index',
        component: () => import('@/views/userAnalysis/index.vue'),
        name: 'EffectData',
        meta: {
          title: '效果数据',
          icon: 'component',
          roles: [
            'ad_reports.index'
          ]
        }
      },
      {
        path: '/newPolicy/index',
        component: () => import('@/views/newPolicy/index.vue'),
        name: 'newPolicy',
        meta: {
          title: '新增策略',
          icon: 'component',
          roles: [
            'ad_reports.index'
          ]
        }
      },
      {
        path: '/timedPush/index',
        component: () => import('@/views/timedPush/index.vue'),
        name: 'timedPush',
        meta: {
          title: '定时推送',
          icon: 'component',
          roles: [
            'ad_reports.index'
          ]
        }
      },
      {
        path: '/menumanagement/index',
        component: () => import('@/views/menumanagement/index.vue'),
        name: 'menumanagement',
        meta: {
          title: '菜单管理',
          icon: 'component',
          roles: [
            'ad_reports.index'
          ]
        }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard'
    // children: [
    //   {
    //     path: 'dashboard',
    //     component: () => import('@/views/dashboard/index'),
    //     name: 'Dashboard',
    //     meta: { title: 'dashboard', icon: 'dashboard', affix: true }
    //   }
    // ]
  },

  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'profile', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/dashboard/index.vue'),
        name: 'Dashboard',
        meta: { title: '首页', noCache: true }
      }
    ]
  }
  // {
  //   path: '/icon',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/icons/index'),
  //       name: 'Icons',
  //       meta: { title: 'icons', icon: 'icon', noCache: true }
  //     }
  //   ]
  // }

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  system,

  permission,

  extension,

  // messageManagement,

  // officialAccountManagement,

  // timedPush,

  warningException,

  enterpriseWechat,

  enterprisewechatControl,

  // merchantnumber,

  anonymousLetter,

  // statistics,

  avataracquisition,
  /* userAnalysis, */

  // rankinglist,

  // eventmanagement,

  domainnamedetect,

  mobilePhoneScanningCode,

  operateCenter,

  recordStatistics,

  merChant,

  advertisement,

  wecomchat,

  /* detectEnterpriseWeChat, */
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
